export default "__VITE_ASSET__D6DX2F3v__"